var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center_bottom"},[_c('Echart',{staticClass:"echarts_bottom",attrs:{"options":_vm.options,"id":"bottomLeftChart"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }